<template>
  <div class="dashboard">
    <div class="line-1">
      <el-row  type="flex" justify="space-between">
        <el-col :span="5">
          <div class="grid-content trucks">
            <div class="title">Trucks</div>
            <div class="num">{{ this.count.vehicle }}</div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content alarm">
            <div class="title">Alert</div>
            <div class="num">{{ this.count.alert }}</div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content gateway">
            <div class="title">Online Gateway</div>
            <div class="num">{{ this.count.gateway }}</div>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content sensor">
            <div class="title">Sensors</div>
            <div class="num">{{ this.count.sensor }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="line-2">
      <el-row>
        <el-col :span="12">
          <div id="chartColumn" style="width: 100%; height:400px;"></div>
        </el-col>
        <el-col :span="12">
          <div id="chartLine" style="width: 100%; height:400px;"></div>
        </el-col>
      </el-row>
    </div>
    <div class="line-3">
      <el-row>
        <el-col :span="24" :offset="0">
          <h2>Alarm List</h2>

          <el-table
            :data="tableData"
            border
            stripe
            style="width: 100%"
            :header-cell-style="{ textAlign: 'center' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="id" label="S/N" width="100">
              <template slot-scope="{ row, $index }">
                <span>{{$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="vehicle_plate" label="Plate" width="250"></el-table-column>
            <el-table-column prop="tyre_id" label="Sensor ID" width="250"></el-table-column>
            <el-table-column 
              prop="message" 
              label="Message"
              style="text-align: left;"
              >

            </el-table-column>
            <el-table-column prop="time" label="Time" width="300">
              <template slot-scope="scope">
                <span>{{ moment(scope.row.time).format('YYYY-MM-DD HH:mm') }}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      
    </div>
  </div>
</template>

<script>
  import * as echarts from 'echarts'
  import moment from 'moment'

  import { getDashboardCount } from "network/dashboard";
  import { getAlertDayList } from "network/alert";

  export default {
    name: "Dashboard",
    data() {
      return {
        count: {
          vehicle: 0,
          gateway: 0,
          sensor: 0,
          alert: 0
        },
        chartColumn: null,
        chartLine: null,
        tableData: [],
        moment: moment
      }
    },
    created() {
    },
    mounted() {
      this.getCount()
      this.getAlert()
      this.drawColumnChart()
      this.drawLineChart()
    },
    methods: {
      getCount() {
        getDashboardCount()
          .then((data) => {
            const result = data.data;
            this.count.vehicle = result.vehicle
            this.count.gateway = result.gateway
            this.count.sensor = result.sensor
          })
          .catch((err) => {
            this.$message.error("Interface error: get_dashboard_count");
          });
      },
      getAlert() {
        getAlertDayList()
          .then((data) => {
            this.tableData = data.data;
            this.count.alert = this.tableData.length;
          })
          .catch((err) => {
            this.$message.error("Interface error: get_alert_list");
          });
      },
      getMonthArray() {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // 月份从0开始，所以要+1
        
        let months = [];
        for (let i = 7; i >= 0; i--) { // 从当前月往前7个月开始
          const date = new Date(currentYear, currentMonth - 1 - i, 1);
          const year = date.getFullYear();
          const month = (date.getMonth() + 1).toString().padStart(2, '0');
          months.push(`${year}-${month}`);
        }
        return months;
      },
      drawColumnChart() {
        const monthArray = this.getMonthArray();
        this.chartColumn = echarts.init(document.getElementById('chartColumn'))
        this.chartColumn.setOption({
          title: { 
            text: 'Trucks',
            left: 'center'
          }, 
          tooltip: {},
          xAxis: {
            data: monthArray  // 使用动态生成的月份数组
          },
          yAxis: {},
          series: [{
            name: 'Number',
            type: 'bar',
            data: [5, 20, 36, 10, 10, 20, 50, 30]
          }]
        })
      },
      drawLineChart() {
        const monthArray = this.getMonthArray();
        this.chartLine = echarts.init(document.getElementById('chartLine'))
        this.chartLine.setOption({
          title: {
            text: 'Alarm',
            left: 'center'
          },
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: monthArray  // 使用动态生成的月份数组
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: 'Number',
              type: 'line',
              data: [120, 132, 101, 134, 90, 230, 210, 90],
              itemStyle: {
                color: '#e66'
              },
              lineStyle: {
                color: '#e66'
              }
            }
          ]
        })
      },

    },
  }
</script>

<style scoped>
  ::v-deep.el-main{
    background: red;
  }
  .dashboard{
    padding-top: 20px;
    width: 100%;
    min-height: calc(100vh - 150px);
  }
  .line-1 .el-row {
    margin-bottom: 40px;
    
  }
  .line-1 .bg-purple {
    background: #d3dce6;
  }

  .line-1 .grid-content {
    border-radius: 10px;
    min-height: 160px;
    padding: 20px;
    color: #fff;
    text-align: center;
  }
  .line-1 .title {
    margin-bottom: 20px;
    text-align: left;
    font-size: 22px;
  }
  .line-1 .num {
    font-size: 40px;
    font-weight: bold;
    letter-spacing: 4px
  }
  .line-1 .trucks {
    background: #ffae2d;
  }
  .line-1 .alarm {
    background: #e96259;
  }
  .line-1 .gateway {
    background: #50bba0;
  }
  .line-1 .sensor {
    background: #108188;
  }
  .line-2{
    margin-bottom: 40px;
  }
  .line-3 {
    margin-bottom: 40px;
  }
  .line-3 h2{
    text-align: center;
    margin-bottom: 20px;
  }
</style>